import React from "react";
import { useLang } from "../i18n";

function Footer({ wide = false }) {
  const { t } = useLang();

  return (
    <footer className="site-footer relative z-[1] px-5 py-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] sm:px-8">
      <div className={`mx-auto flex w-full items-center justify-between gap-4 ${wide ? "max-w-[1040px]" : "max-w-[760px]"}`}>
        <span>{t.footer}</span>
        <span>© 2026</span>
      </div>
    </footer>
  );
}

export default Footer;
